import { call, put, select, takeLatest } from "redux-saga/effects";
import { LOAD_COMMUNICATION, UPDATE_COMMUNICATION } from "./constants";
import {
  loadCommunicationSuccess,
  loadCommunicationError,
  updateCommunicationSuccess,
  updateCommunicationError,
} from "./actions";

import requestWrapper from "utils/requestWrapper";

// utils
import api from "utils/api";
const { endpoint } = api;
import _local from "utils/localStorageUtils";

export function* loadCommunicationSaga(action) {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield _local.getLocalUser();
    const { detailID } = action;
    const newKey = "new";
    let itemDetailSaga = false;
    // we get the campaigns linked to the communication
    if (!!detailID && detailID != newKey) {
      // we get the campaigns linked to the communication
      itemDetailSaga = yield requestWrapper(
        "GET",
        endpoint?.communications?.teacher?.single(detailID),
        // `communications/${detailID}`,
        "",
        currentUser.token,
      );
    }

    if (!detailID && !itemDetailSaga) {
      yield put(loadCommunicationSuccess(false));
    } else {
      yield put(loadCommunicationSuccess(itemDetailSaga));
    }
  } catch (error) {
    yield put(loadCommunicationError(error));
  }
}

export function* updateCommunicationSaga(action) {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield _local.getLocalUser();

    const userID = currentUser?._id;

    const { itemDetail } = action;
    const ID = itemDetail?._ID;

    const newKey = "new";
    let updatedElemnet = false;
    if (!!ID && ID != newKey) {
      updatedElemnet = yield requestWrapper(
        "PATCH",
        endpoint?.communications?.teacher?.update(ID),
        itemDetail,
        currentUser.token,
      );
    }

    if (!updatedElemnet) {
      yield put(updateCommunicationSuccess(false));
    } else {
      yield put(updateCommunicationSuccess(updatedElemnet));
    }
  } catch (err) {
    yield put(updateCommunicationError(true));
  }
}

// Individual exports for testing
export default function* communicationDetailMobileSaga() {
  // See example in containers/HomePage/saga.js
  yield takeLatest(LOAD_COMMUNICATION, loadCommunicationSaga);
  yield takeLatest(UPDATE_COMMUNICATION, updateCommunicationSaga);
}
